export const container = () => ({
    display: 'none',

    tablet: {
        display: 'flex',
        position: 'fixed',
        right: '1.6875rem',
        top: '0',
        bottom: '0',
        willChange: 'transform',
        zIndex: '10',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
    },
});
